//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './SubscriptionOptionsClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetByLevelSubscriptionOptionsQueryParameters = {
  level?: string | undefined ;
}

export function getByLevelUrl(level?: string | undefined): string {
  let url_ = getBaseUrl() + "/api/subscription-options?";
if (level === null)
    throw new Error("The parameter 'level' cannot be null.");
else if (level !== undefined)
    url_ += "level=" + encodeURIComponent("" + level) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getByLevelDefaultOptions: Omit<UseQueryOptions<Types.SubscriptionOptionDto, unknown, Types.SubscriptionOptionDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.SubscriptionOptionDto, unknown, Types.SubscriptionOptionDto>, 'queryFn'>> = {
};
export function getGetByLevelDefaultOptions() {
  return getByLevelDefaultOptions;
};
export function setGetByLevelDefaultOptions(options: typeof getByLevelDefaultOptions) {
  getByLevelDefaultOptions = options;
}

export function getByLevelQueryKey(level?: string | undefined): QueryKey;
export function getByLevelQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { level,  } = params[0] as GetByLevelSubscriptionOptionsQueryParameters;

    return trimArrayEnd([
        'SubscriptionOptionsClient',
        'getByLevel',
        level as any,
      ]);
  } else {
    return trimArrayEnd([
        'SubscriptionOptionsClient',
        'getByLevel',
        ...params
      ]);
  }
}
export function __getByLevel(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getByLevel(
      context.queryKey[2] as string | undefined,axiosConfig    );
}

export function useGetByLevelQuery<TSelectData = Types.SubscriptionOptionDto, TError = unknown>(dto: GetByLevelSubscriptionOptionsQueryParameters, options?: Omit<UseQueryOptions<Types.SubscriptionOptionDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets subscription options details.
 * @param level (optional) Level of requested subscription.
 */
export function useGetByLevelQuery<TSelectData = Types.SubscriptionOptionDto, TError = unknown>(level?: string | undefined, options?: Omit<UseQueryOptions<Types.SubscriptionOptionDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetByLevelQuery<TSelectData = Types.SubscriptionOptionDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.SubscriptionOptionDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let level: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ level,  } = params[0] as GetByLevelSubscriptionOptionsQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [level, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.SubscriptionOptionDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getByLevel(context, axiosConfig) : __getByLevel,
    queryKey: getByLevelQueryKey(level),
    ...getByLevelDefaultOptions as unknown as Omit<UseQueryOptions<Types.SubscriptionOptionDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets subscription options details.
 * @param level (optional) Level of requested subscription.
 */
export function setGetByLevelData(queryClient: QueryClient, updater: (data: Types.SubscriptionOptionDto | undefined) => Types.SubscriptionOptionDto, level?: string | undefined) {
  queryClient.setQueryData(getByLevelQueryKey(level),
    updater
  );
}

/**
 * Gets subscription options details.
 * @param level (optional) Level of requested subscription.
 */
export function setGetByLevelDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.SubscriptionOptionDto | undefined) => Types.SubscriptionOptionDto) {
  queryClient.setQueryData(queryKey, updater);
}